(() => {
  const calme = matchMedia('(prefers-reduced-motion: reduce)').matches
  requestAnimationFrame(() => requestAnimationFrame(() => document.body.classList.remove('chargement')))

  // Carte 3D qui suit la souris
  document.querySelectorAll('.carte').forEach((carte) => {
    if (calme) return
    carte.addEventListener('pointermove', (e) => {
      const r = carte.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height
      carte.style.transform = `rotateY(${(x - .5) * 16}deg) rotateX(${(.5 - y) * 12}deg)`
      carte.style.setProperty('--mx', `${x * 100}%`); carte.style.setProperty('--my', `${y * 100}%`)
    })
    carte.addEventListener('pointerleave', () => { carte.style.transform = '' })
  })

  // Barres de défilement : visibles seulement pendant le défilement
  let minuterie = 0
  const montre = () => { document.documentElement.classList.add('defile'); clearTimeout(minuterie); minuterie = setTimeout(() => document.documentElement.classList.remove('defile'), 900) }
  addEventListener('scroll', montre, { passive: true, capture: true })
  addEventListener('wheel', montre, { passive: true })

  // Menu compact (téléphone et tablette)
  const mb = document.querySelector('.menu-btn')
  if (mb) mb.addEventListener('click', () => {
    const o = document.body.classList.toggle('menu-ouvert'); mb.setAttribute('aria-expanded', String(o))
  })

  // Onglets de la fiche produit (le client clique au lieu de descendre)
  const onglets = document.querySelectorAll('.onglets [role="tab"]')
  onglets.forEach((b) => b.addEventListener('click', () => {
    onglets.forEach((o) => { o.setAttribute('aria-selected', String(o === b)); document.getElementById(o.getAttribute('aria-controls')).hidden = o !== b })
  }))

  // Bascule des captures de la console
  document.querySelectorAll('.bascule button').forEach((b) => b.addEventListener('click', () => {
    b.parentElement.querySelectorAll('button').forEach((o) => o.setAttribute('aria-pressed', String(o === b)))
    const img = document.getElementById(b.dataset.cible); img.src = b.dataset.src; img.alt = b.dataset.alt
  }))

  // Étoiles dorées (souris seulement) : plusieurs à chaque mouvement, rapprochées
  if (!calme && matchMedia('(pointer: fine)').matches && document.body.classList.contains('ouverture')) {
    let dernier = 0
    addEventListener('pointermove', (e) => {
      const t = performance.now(); if (t - dernier < 70) return; dernier = t
      const n = 1
      for (let i = 0; i < n; i++) {
        const s = document.createElement('span'); s.className = 'etoile'
        s.style.left = e.clientX + (Math.random() - .5) * 18 + 'px'; s.style.top = e.clientY + (Math.random() - .5) * 18 + 'px'
        const k = .6 + Math.random() * .4; s.style.width = s.style.height = 14 * k + 'px'
        s.style.animationDuration = 650 + Math.random() * 350 + 'ms'
        document.body.appendChild(s); setTimeout(() => s.remove(), 1050)
      }
    }, { passive: true })
  }

})()

// Achat : « Acheter maintenant » ouvre « Avant de payer » (renonciation à la rétractation),
// puis ajoute l'agent au panier, enregistre l'accord sur la commande et ouvre le paiement.
;(() => {
  const form = document.getElementById('form-achat')
  const dlg = document.getElementById('avant-paiement')
  if (!form || !dlg || typeof dlg.showModal !== 'function') return
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
  const acheter = form.querySelector('[data-acheter]')
  const coche = dlg.querySelector('#renonce-produit')
  const payer = dlg.querySelector('[data-payer]')
  const erreur = dlg.querySelector('#erreur-paiement')
  let ouvreur = null

  acheter && acheter.addEventListener('click', (e) => { e.preventDefault(); ouvreur = acheter; erreur.hidden = true; dlg.showModal(); coche.focus() })
  dlg.querySelector('[data-fermer]').addEventListener('click', () => dlg.close())
  dlg.addEventListener('close', () => ouvreur && ouvreur.focus())
  coche.addEventListener('change', () => { payer.disabled = !coche.checked })

  payer.addEventListener('click', async () => {
    if (!coche.checked) return
    payer.disabled = true; payer.textContent = 'Un instant…'
    try {
      const envoi = (url, corps) => fetch(racine + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.json() })
      const id = form.querySelector('[name="id"]').value
      const panier = await fetch(racine + 'cart.js').then((r) => r.json())
      if (!panier.items.some((i) => String(i.variant_id) === String(id))) await envoi('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      await envoi('cart/update.js', { attributes: { 'Renonciation au droit de rétractation': coche.dataset.valeur } })
      location.href = racine + 'checkout'
    } catch (err) {
      erreur.hidden = false; payer.disabled = false; payer.textContent = 'Passer au paiement'
    }
  })
})()

// La bille d'onyx remplace le « O » d'Onyxvia dans tous les textes du site
;(() => {
  const src = document.documentElement.dataset.bille
  if (!src) return
  const exclus = 'script,style,title,textarea,input,option,.logo,.bille,[data-sans-bille]'
  const marcheur = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => (n.nodeValue.includes('Onyxvia') && !n.parentElement.closest(exclus)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT,
  })
  const noeuds = []
  while (marcheur.nextNode()) noeuds.push(marcheur.currentNode)
  noeuds.forEach((n) => {
    const frag = document.createDocumentFragment()
    n.nodeValue.split('Onyxvia').forEach((morceau, i) => {
      if (i > 0) {
        const b = document.createElement('span'); b.className = 'bille'
        const img = document.createElement('img'); img.src = src; img.alt = 'O'; img.width = 16; img.height = 16
        b.append(img, 'nyxvia'); frag.append(b)
      }
      if (morceau) frag.append(morceau)
    })
    n.replaceWith(frag)
  })
})()

// Galerie de la fiche produit, façon Amazon : miniatures en colonne, survol ou clic = aperçu,
// clic sur la grande photo = plein écran (flèches et clavier)
;(() => {
  const donnees = document.getElementById('galerie-donnees')
  if (!donnees) return
  const photos = JSON.parse(donnees.textContent)
  const principale = document.querySelector('.photo-principale')
  const zoneCarte = principale && principale.querySelector('.zone-carte')
  const grande = principale && principale.querySelector('.grande')
  const vignettes = [...document.querySelectorAll('.colonne-vignettes .vignette-g')]
  let courant = 0
  const afficher = (n) => {
    courant = n
    vignettes.forEach((v, k) => { v.classList.toggle('active', k === n); if (k === n) v.setAttribute('aria-current', 'true'); else v.removeAttribute('aria-current') })
    if (!grande) return
    if (n === 0) { grande.hidden = true; zoneCarte.hidden = false }
    else { grande.src = photos[n].moyen; grande.alt = photos[n].alt || ''; grande.hidden = false; zoneCarte.hidden = true }
  }
  const precharger = () => photos.forEach((ph) => { const im = new Image(); im.src = ph.moyen })
  if ('requestIdleCallback' in window) requestIdleCallback(precharger); else setTimeout(precharger, 1500)
  vignettes.forEach((v) => {
    const n = Number(v.dataset.index)
    v.addEventListener('mouseenter', () => afficher(n))
    v.addEventListener('focus', () => afficher(n))
    v.addEventListener('click', () => afficher(n))
  })

  const dlg = document.getElementById('visionneuse')
  if (!dlg || typeof dlg.showModal !== 'function') return
  const img = document.getElementById('vis-img'), legende = document.getElementById('vis-legende')
  let i = 0, ouvreur = null
  const montrer = (n) => { i = (n + photos.length) % photos.length; img.src = photos[i].src; img.alt = photos[i].alt || ''; legende.textContent = photos[i].alt || '' }
  const ouvrir = (n, depuis) => { ouvreur = depuis; montrer(n); dlg.showModal() }
  if (principale) {
    principale.addEventListener('click', (e) => { e.preventDefault(); ouvrir(courant, principale) })
    principale.tabIndex = 0
    principale.setAttribute('role', 'button')
    principale.setAttribute('aria-label', 'Agrandir la photo')
    principale.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ouvrir(courant, principale) } })
  }
  document.querySelectorAll('[data-ouvrir-galerie]').forEach((b) => b.addEventListener('click', () => ouvrir(Number(b.dataset.index), b)))
  dlg.querySelector('[data-prec]').addEventListener('click', () => montrer(i - 1))
  dlg.querySelector('[data-suiv]').addEventListener('click', () => montrer(i + 1))
  dlg.querySelector('[data-fermer-vis]').addEventListener('click', () => dlg.close())
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close() })
  dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') montrer(i - 1); if (e.key === 'ArrowRight') montrer(i + 1) })
  dlg.addEventListener('close', () => ouvreur && ouvreur.focus())
})()

// Panier : une seule licence par agent (ramène une quantité > 1 à 1)
;(() => {
  const lignes = [...document.querySelectorAll('.lignes-panier li[data-cle]')].filter((l) => Number(l.dataset.qte) > 1)
  if (!lignes.length) return
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
  Promise.all(lignes.map((l) => fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: l.dataset.cle, quantity: 1 }) })))
    .then(() => location.reload()).catch(() => {})
})()

// Bannière de cookies : « Gérer vos préférences » devient un vrai bouton « Personnaliser »
;(() => {
  let essais = 0
  const renommer = () => {
    const b = document.querySelector('#shopify-pc__banner__btn-manage-prefs span')
    if (b) { b.textContent = 'Personnaliser'; return }
    if (++essais < 40) setTimeout(renommer, 250)
  }
  renommer()
})()

// Vidéo de présentation : s'ouvre en grand, démarre au clic, s'arrête à la fermeture
;(() => {
  const dlg = document.getElementById('visionneuse-video')
  if (!dlg || typeof dlg.showModal !== 'function') return
  const video = document.getElementById('video-presentation')
  let ouvreur = null
  document.querySelectorAll('[data-ouvrir-video]').forEach((b) => b.addEventListener('click', () => {
    ouvreur = b; dlg.showModal(); video.currentTime = 0; video.play().catch(() => {})
  }))
  dlg.querySelector('[data-fermer-video]').addEventListener('click', () => dlg.close())
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close() })
  dlg.addEventListener('close', () => { video.pause(); if (ouvreur) ouvreur.focus() })
})()

// Pied de page : rouvrir les préférences de cookies (retirer ou modifier son consentement à tout moment)
;(() => {
  const b = document.querySelector('.gerer-cookies')
  if (!b) return
  const ouvrir = () => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return true }
    const bouton = document.getElementById('shopify-pc__banner__btn-manage-prefs')
    if (bouton) { bouton.click(); return true }
    return false
  }
  let essais = 0
  const pret = () => {
    if ((window.privacyBanner && window.privacyBanner.showPreferences) || document.getElementById('shopify-pc__banner')) { b.hidden = false; return }
    if (++essais < 40) setTimeout(pret, 250)
  }
  pret()
  b.addEventListener('click', ouvrir)
})()

// Panneau latéral du panier : s'ouvre uniquement au survol du bouton « Panier » (souris)
;(() => {
  const tiroir = document.getElementById('tiroir-panier')
  const lien = document.querySelector('.panier-lien')
  if (!tiroir || !lien) return
  const corps = tiroir.querySelector('.tiroir-corps')
  let minuteur = 0
  const ouvrir = () => {
    clearTimeout(minuteur)
    if (!tiroir.hidden) return
    tiroir.hidden = false
    lien.setAttribute('aria-expanded', 'true')
    requestAnimationFrame(() => tiroir.classList.add('ouvert'))
    document.documentElement.style.overflow = 'hidden'
  }
  const fermer = () => {
    clearTimeout(minuteur)
    tiroir.classList.remove('ouvert')
    lien.setAttribute('aria-expanded', 'false')
    document.documentElement.style.overflow = ''
    setTimeout(() => { if (!tiroir.classList.contains('ouvert')) tiroir.hidden = true }, 260)
  }
  {
    lien.addEventListener('mouseenter', () => { minuteur = setTimeout(ouvrir, 180) })
    lien.addEventListener('mouseleave', () => clearTimeout(minuteur))
    corps.addEventListener('mouseleave', () => { minuteur = setTimeout(fermer, 450) })
    corps.addEventListener('mouseenter', () => clearTimeout(minuteur))
  }
  // Clic sur « Panier » : page du panier, comme un lien normal (le panneau ne s'ouvre qu'au survol)
  tiroir.querySelectorAll('[data-fermer-tiroir]').forEach((b) => b.addEventListener('click', fermer))
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !tiroir.hidden) { fermer(); lien.focus() } })
})()

// Panier et panneau : « Passer au paiement » reste grisé tant que la case de renonciation n'est pas cochée
;(() => {
  document.querySelectorAll('.panier-form, .tiroir-form').forEach((f) => {
    const c = f.querySelector('.renonce input[type=checkbox]')
    const b = f.querySelector('button[name=checkout]')
    if (!c || !b) return
    const aide = document.createElement('p'); aide.className = 'aide-case'; aide.setAttribute('data-attente-case', '')
    aide.textContent = 'Cochez la case ci-dessus pour passer au paiement.'
    b.insertAdjacentElement('beforebegin', aide)
    const maj = () => { b.disabled = !c.checked; aide.hidden = c.checked }
    c.addEventListener('change', maj); maj()
    f.addEventListener('submit', (e) => { if (!c.checked) { e.preventDefault(); aide.hidden = false } })
  })
})()
